/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Team_Share_Created_OnInputs */

const en_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const fr_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const de_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const it_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const ru_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const es_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const zh_cn2_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const ja_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const hi_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

const pt_pt2_team_share_created_on = /** @type {(inputs: Team_Share_Created_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Team_Share_Created_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_created_on = /** @type {((inputs: Team_Share_Created_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Created_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_created_on(inputs)
	if (locale === "de") return de_team_share_created_on(inputs)
	if (locale === "it") return it_team_share_created_on(inputs)
	if (locale === "ru") return ru_team_share_created_on(inputs)
	if (locale === "es") return es_team_share_created_on(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_created_on(inputs)
	if (locale === "ja") return ja_team_share_created_on(inputs)
	if (locale === "hi") return hi_team_share_created_on(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_created_on(inputs)
	return en_team_share_created_on(inputs)
});